import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { TableOfContentType } from '../../types';
import TOCModalMiddle from '@components/toc-modal/toc-modal-middle';
import TOCModalLeft from '@components/toc-modal/toc-modal-left';
interface TableOfContentModalPropType {
  toc: TableOfContentType[];
  closeModal: Function;
  modalOpen: boolean;
}

const TableOfContentModal = ({
  toc,
  closeModal,
  modalOpen = false,
}: TableOfContentModalPropType) => {
  return (
    <>
      <div
        className={ivclass(
          'iv-sticky',
          'iv-right-0',
          'iv-top-[60px]',
          'md:iv-hidden sm:iv-hidden',
        )}
      >
        {modalOpen && <TOCModalLeft toc={toc} closeModal={closeModal} />}
      </div>
      <div className={ivclass('xl:iv-hidden lg:iv-hidden')}>
        {modalOpen && (
          <TOCModalMiddle
            modalOpen={modalOpen}
            toc={toc}
            closeModal={closeModal}
          />
        )}
      </div>
    </>
  );
};

export default TableOfContentModal;
